import { startExtraction, type DocumentOut } from "@/api";
import { needsPageChoice } from "@/lib/pageChoice";

/**
 * Queues the reading for the drawings stored on a Vorgang — or, where a person
 * has to say which page is read, queues nothing.
 *
 * Seitenwahl (13.10.2026): the reading chain reads one page. With more than
 * one page on file, nothing is read on the drop — not even page 1 — and the
 * reading's own screen asks which (`needsPageChoice`). Nothing here writes a
 * Stand; the reading is a proposal a person takes over later (A-014).
 *
 * Pulled out of `DropArea` so the mail's „Eingang" starts a reading exactly
 * the way the start page's drop does. The caller navigates to
 * `/vorgang/${caseId}/einlesen` afterwards, started or not.
 */
export async function startReading(caseId: string, documents: DocumentOut[]): Promise<void> {
  if (needsPageChoice(documents)) return;
  await startExtraction(
    caseId,
    documents.map((document) => document.id),
  );
}
